
import { Component, Vue, Prop } from "vue-property-decorator";
@Component({
  components: {}
})
export default class EyeIcon extends  Vue {
  @Prop({  required: false, default: '100%' }) readonly width!: string | number;
  @Prop({  required: false, default: '100%' }) readonly height!: number | string;
  @Prop({  required: false, default: 'currentColor' }) readonly stroke!: string;
}
